module.exports = "/ui/design/images/slick-next-sm.png?c8cccbeecdf836397aa763494fbfd32c";